import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

const CollapsiblePanelComponent = ({
  onToggle,
  expanded,
  title,
  children,
  minimal,
  panelStyle
}) => (
  <div className={minimal ? 'minimal' : ''}>
    <Panel
      collapsible="true"
      onToggle={onToggle}
      expanded={expanded}
      bsStyle={panelStyle}
    >
      <Panel.Heading>
        <Panel.Title toggle>
          {title}
        </Panel.Title>
      </Panel.Heading>
      <Panel.Collapse>
        <Panel.Body>
          {expanded ? children : null}
        </Panel.Body>
      </Panel.Collapse>
    </Panel>
  </div>
);

CollapsiblePanelComponent.propTypes = {
  onToggle: PropTypes.func.isRequired,
  expanded: PropTypes.bool,
  title: PropTypes.any.isRequired,
  children: PropTypes.any,
  minimal: PropTypes.bool,
  panelStyle: PropTypes.string
};

export default CollapsiblePanelComponent;


// WEBPACK FOOTER //
// src/Components/CollapsiblePanelComponent.jsx